import { axiosInstance as axios } from "services";

export const blockCompany = async (companyId, body) => {
  const { data } = await axios.post(`/admin/subscription/company/${companyId}/block`, body);
  if (!data.success) throw new Error(data.error?.message || "Failed to block company");
  return data;
};

